export default __webpack_public_path__ + "static/media/san-rafael-7.516d7d2d.jpg";